// set function parseTime,formatTime to filter
import { parseTime } from '@/util/date'

export function dateYMD(date) {
  return parseTime(date, '{y}-{m}-{d}')
}

